<div
	class="cf_geo-visualizer"
	[ngStyle]="{
		'max-width': themeSettings.map.maxWidth,
		'max-height': themeSettings.map.maxHeight,
		width: '90vw',
		height: 'calc(90vw / ' + themeSettings.map.aspectRatio + ')',
	}"
>
	@if(!mapboxFailed()){
	<div class="cf_geo-visualizer-markers">
		@for(locationMarker of locationsToShow; track locationMarker.name ) {
		<location-indicator
			[tooltipHandler]="tooltipHandler"
			[locationMarker]="locationMarker"
			[invertLabel]="true"
		>
		</location-indicator>
		}
	</div>
	<div [id]="ID" class="cf_geo-visualizer-map" #map></div>
	} @else {
	<div class="web-gl-error">{{ hardwareAccelRequired }}</div>
	}
</div>
